import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

interface StyledRequiredLabelProps {
  $error?: boolean;
}

interface RequiredLabelProps {
  error?: boolean;
}

const StyledRequiredLabel = styled('span')<StyledRequiredLabelProps>(
  ({ theme, $error }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '1px 4px',
    fontWeight: 500,
    fontSize: '0.6rem',
    lineHeight: 1,
    verticalAlign: 'middle',
    position: 'relative',
    top: '-3px',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    borderRadius: '1rem',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: $error ? '#ff2020' : theme.palette.divider,
  })
);

const RequiredLabel = ({ error }: RequiredLabelProps) => (
  <StyledRequiredLabel $error={error}>
    <FormattedMessage id="form.required" defaultMessage="required" />
  </StyledRequiredLabel>
);

export { RequiredLabel };
